/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const LogoutIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="20px"
      width="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.48517 5.27771H5.92033C5.54958 5.27771 5.24902 5.57826 5.24902 5.94902V14.0509C5.24902 14.4217 5.54958 14.7222 5.92033 14.7222H9.48517V15.9722H5.92033C4.85922 15.9722 3.99902 15.112 3.99902 14.0509V5.94902C3.99902 4.88791 4.85922 4.02771 5.92033 4.02771H9.48517V5.27771ZM7.8785 10.625L13.6082 10.625L11.6654 12.5678L12.5493 13.4517L15.559 10.4419L16.0009 9.99999L15.559 9.55805L12.5493 6.54831L11.6654 7.4322L13.6082 9.37499L7.8785 9.37499V10.625Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
